import React from 'react'
import {getTaskTypeIconParser} from '../shared/enums/task-type-icon-parser'
import {getIntervalParser} from '../shared/enums/interval-enum-parser'
import {getPackageTypeParser} from '../shared/enums/package-type-parser'
import { Modal } from 'react-bootstrap'
import ServiceFrequency from '../modals/components/service-frequency'
import ServicePlan from '../modals/components/service-plan'
import Instruction from '../modals/components/instructions'

let smallData = {
  cost: 666,
  interval: 'WEEKLY',
  orderedDate: 1473173151165,
  packageType: 'BASIC',
  scheduleAddon: 'TASKEASY_SCHEDULE',
  serviceEndDate: 'Date service ended: 11/01/2016',
  taskComment: 'No instructions',
  taskDescription: 'Weekly / Budget / TaskEasy Schedule',
  taskId: 641103,
  taskStatus: 'ACTIVE',
  taskType: 'MOWLAWN',
  workFlowStep: 'OFFSEASON',
  comment: 'This is a test comment',
  intervalDisplay: {
     title: 'Weekly'
  },
  packageDisplay: {
    title: 'Budget'
  }
}


export default React.createClass({

  render: function () {
    let task = this.props.task
    if (task === undefined) {
      task = smallData
    }
    else if(task === '') {
      task = smallData
    }

    let taskType = task.taskType
    let iconTypeInfo = getTaskTypeIconParser(taskType)
    let taskTitle = iconTypeInfo.prettify
    let taskIcon = iconTypeInfo.iconsrc
    let taskDescription
    if(!task.taskDescription) {
      taskDescription = task.intervalDisplay.title + ' / ' + task.packageDisplay.title + ' / ' + task.scheduleDisplay.title
    }
    else {
      taskDescription = task.taskDescription
    }

    let costOfService
    if(this.props.actualCost) {
        costOfService = this.props.actualCost
      }
    else {
        costOfService = task.cost
     }

    let serviceFrequencyBlock
    let servicePlanBlock
    let instructions
    let hideAllButtons;

    if(task.workFlowStep === 'CLOSED'){
      hideAllButtons = true;
    }

    switch(taskTitle) {
      case 'Lawn Mowing':
        if (task.packageDisplay) {
          servicePlanBlock = <ServicePlan hideAllButtons={hideAllButtons} name={task.packageDisplay.title} openUpgradeServiceModal={() => this.props.openUpgradeServiceModal(task)} packageType={task.packageDisplay.taskDisplayOption} fullComponent={this.props.fullComponent}/>
        }
        else if(task.packageType) {
          let formattedServicePlan = getPackageTypeParser(task.packageType).capitalizedText
          servicePlanBlock = <ServicePlan hideAllButtons={hideAllButtons} name={formattedServicePlan}  openUpgradeServiceModal={() => this.props.openUpgradeServiceModal(task)} packageType={task.packageType} fullComponent={this.props.fullComponent}/>
        }

        if (task.intervalDisplay) {
          serviceFrequencyBlock = <ServiceFrequency hideAllButtons={hideAllButtons} name={task.intervalDisplay.title}  openUpgradeFrequencyModal={() => this.props.openUpgradeFrequencyModal(task)}/>
        }
        else if(task.interval) {
          let formattedInterval = getIntervalParser(task.interval).capitalizedText
          serviceFrequencyBlock = <ServiceFrequency hideAllButtons={hideAllButtons} name={formattedInterval} openUpgradeFrequencyModal={() => this.props.openUpgradeFrequencyModal(task)}/>
        }
      break;
      case'Snow Removal':
        if (task.packageDisplay) {
          servicePlanBlock = <ServicePlan hideAllButtons={hideAllButtons} name={task.packageDisplay.title}  openUpgradeServiceModal={() => this.props.openUpgradeServiceModal(task)} fullComponent={this.props.fullComponent}/>
        }
        else if(task.packageType) {
          let formattedServicePlan = getPackageTypeParser(task.packageType).capitalizedText
          servicePlanBlock = <ServicePlan hideAllButtons={hideAllButtons} name={formattedServicePlan} openUpgradeServiceModal={() => this.props.openUpgradeServiceModal(task)} fullComponent={this.props.fullComponent}/>
        }
        if (task.intervalDisplay) {
          serviceFrequencyBlock = <ServiceFrequency hideAllButtons={hideAllButtons} name={task.intervalDisplay.title} openUpgradeFrequencyModal={() => this.props.openUpgradeFrequencyModal(task)}/>
        }
        else if(task.interval) {
          let formattedInterval = getIntervalParser(task.interval).capitalizedText
          serviceFrequencyBlock = <ServiceFrequency hideAllButtons={hideAllButtons} name={formattedInterval}  openUpgradeFrequencyModal={() => this.props.openUpgradeFrequencyModal(task)}/>
        }
      break;
      default:
        if (task.intervalDisplay) {
          serviceFrequencyBlock = <ServiceFrequency hideAllButtons={true} name={task.intervalDisplay.title} openUpgradeFrequencyModal={() => this.props.openUpgradeFrequencyModal(task)}/>
        }
        else if(task.interval) {
          let formattedInterval = getIntervalParser(task.interval).capitalizedText
          serviceFrequencyBlock = <ServiceFrequency hideAllButtons={true} name={formattedInterval} openUpgradeFrequencyModal={() => this.props.openUpgradeFrequencyModal(task)}/>
        }
      break;
    }

    if (task.comment) {
      instructions = <Instruction name={task.comment} hideAllButtons={hideAllButtons} openUpdateInstructionsModal={this.props.openUpdateInstructionsModal}/>
    }
    else if(task.taskComment) {
      instructions = <Instruction name={task.taskComment} hideAllButtons={hideAllButtons} openUpdateInstructionsModal={this.props.openUpdateInstructionsModal}/>
    }
    return (

      <div>
        <Modal show={this.props.show} onHide={this.props.hide} dialogClassName='new-task-modal'>
          <Modal.Header closeButton className='concrete-gray-background' style={{borderRadius: 6}}>
            <div className={'task-type center no-text'}>
              <div className={`img-responsive center-block ${taskIcon}-icon`}/>
            </div>
            <h2 className='text-center'>{taskTitle}</h2>
            <br />
            <div className='text-center lead text-nowrap' style={{padding: '0 20px', fontSize: 45}}><b>${costOfService}</b><span style={{fontSize: 25}}>/service</span></div>
            <div className='text-center brand-primary-color' style={{margin: '-15px 0 0 0', fontSize: 20}}>{taskDescription}</div>
            <div className='col-sm-12'>
              {serviceFrequencyBlock}
              {servicePlanBlock}
              {instructions}
            </div>
          </Modal.Header>
        </Modal>
      </div>
    )
  }
})



// WEBPACK FOOTER //
// ./src/components/modals/task-edit-modal.jsx